import React from "react";
import { LogoContent, Header, SideBannerContainer } from "./styles";
import Stepper from "components/layout/Stepper";
import { Link } from "react-router-dom";

const SideBanner = ({
  activated,
  header = {},
  steppers,
}) => {
  return (
    <SideBannerContainer>
      <LogoContent>
        <Link to="/">
          <img
            width={173.42}
            src="/static/ultragaz-logo-white.svg"
            alt="Logo da Ultragaz"
            />
        </Link>
      </LogoContent>
      <Header>
      {header?.h1 && (
        <h1>{header.h1}</h1>
      )}
      {header?.h2 && (
        <h2
        dangerouslySetInnerHTML={{ __html: header.h2 }}
        />
      )}
      </Header>
      <Stepper activated={activated} steppers={steppers} />
    </SideBannerContainer>
  );
}

export default SideBanner;
